<template>
  <field-view-readonly-location
    v-if="source === 'locations'"
    :location-id="id"
    @dismiss="handleDismiss"
  />
  <field-view-readonly-resource v-else :id="id" @dismiss="handleDismiss" />
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router/composables'
import { useFieldView } from './FieldViewState'
import FieldViewReadonlyLocation from './FieldViewReadonlyLocation.vue'
import FieldViewReadonlyResource from './FieldViewReadonlyResource.vue'

defineProps<{
  id: number | string
  source: string
}>()

const router = useRouter()

const { setSelectedLocation, setSelectedResource } = useFieldView()

function handleDismiss() {
  setSelectedLocation(null)
  setSelectedResource(null)
  router.replace({ name: 'field-view-next', hash: router.currentRoute.hash })
}
</script>
